'use client';

import React from 'react';
import Typography from '@/components/_ui/_blocks/Typography/Typography';
import Icon from '../_blocks/Icon/Icon';

import styles from './Accordion.module.css';

export interface AccordionItemProps {
    /**  Injected by Accordion - this determines whether the accordion item needs to be open or not. */
    open?: boolean | undefined;
    /** This is the heading of the accordion item. */
    heading: string;
    /** This is the class name for heading of the accordion item heading. */
    headingClassName?: string;
    /** Class name for the accordion item */
    itemClassName?: string;
    /** Id for the accordion item */
    itemId: string | undefined;
    /** This is the content of the accordion item. */
    children: React.ReactNode;
    name?: string;
}


const AccordionItem = ({
    children,
    heading,
    open = undefined,
    headingClassName = '',
    itemClassName = '',
    itemId = undefined,
    name = undefined
}: AccordionItemProps) => (
    <li className={styles.accordion__item__wrapper}>
        <details
            className={`${styles.accordion__item} ${itemClassName}`}
            data-open={open}
            open={open}
            name={name}
        >
            <summary className='flex justify-between'>
                <Typography
                    typeset="heading"
                    size="100"
                    lineHeight="200"
                    className={headingClassName}
                    dangerouslySetInnerHTML={{ __html: heading }}
                    as="h3"
                    aria-details={itemId}
                />
                <Icon
                    icon="chevron-right-light"
                    alt=""
                    aria-hidden="true"
                    className={styles.accordion__icon}
                    size="medium"
                />
            </summary>
        </details>
        <div id={itemId} className={styles.accordion__content}>
            <Typography as="p">{children}</Typography>
        </div>
    </li>
);

export default AccordionItem;
